<template>
    <router-view/>
</template>
<script>
import { defineComponent } from 'vue'
import { useStore } from '@/composables/store/useStore.js'

export default defineComponent({
  name: 'App',
  components: {
  },
  setup (props, context) {
    const store = useStore()
    store.setUrlApi(process.env.VUE_APP_INI)
  }
})
</script>
